export default __webpack_public_path__ + "static/media/lagos.2036c6a7.png";